import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RecuperarClaveComponent} from './recuperarClave/recuperar-clave.component';
import {RouterModule} from '@angular/router';
import {LockComponent} from './lockScreen/lock.component';
import {LoadingModule} from './loadingScreen/loading.module';
import {ResetClaveComponent} from './resetClave/reset-clave.component';
import {NgStringPipesModule} from '../../pipes/string';
import {AzureLoginComponent} from './azureLogin/azureLogin.component';
import {VerifyAzureLoginComponent} from './verifyAzureLogin/verifyAzureLogin.component';
import { MigrationBannerComponent } from './migrationBanner/migrationBanner.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        LoadingModule,
        NgStringPipesModule
    ],
    declarations: [LoginComponent, AzureLoginComponent, VerifyAzureLoginComponent, RecuperarClaveComponent, LockComponent, ResetClaveComponent, MigrationBannerComponent],
    exports: [LoginComponent, AzureLoginComponent, VerifyAzureLoginComponent, RecuperarClaveComponent, ResetClaveComponent, MigrationBannerComponent]
})
export class AutenticacionModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/autenticacion.module.ts